import { appConfig } from '@fs/zion-config'
import { getBrightspotConfig } from '@fs/zion-rootstech'
import getIsLowBandwidth from '../lib/helpers/getIsLowBandwidth'

export type BrightspotConfig = {
  imageSizes: Record<string, Record<string, number | boolean>>
  query: {
    defaults: {
      visibilityRequest: { status: string }
      pageRequest: { page: number; limit: number }
      creatorTypes: string[]
      imageSize: number
    }
    manualChunkSize: number
    fetchPolicy: { NETWORK_ONLY: 'network-only'; CACHE_FIRST: 'cache-first' }
  }
  apiPaths: { delivery: string; cae: string }
  api: {
    key: string
    uri: string
    conferenceCmsUri: string
    upload: { key: string; url: string }
  }
  objectTypes: Record<string, string>
}

// Web wrapper around the shared config builder: injects the web app's
// env config and bandwidth detection.
export const getBrightspotWebConfig = (): BrightspotConfig =>
  getBrightspotConfig({ lowBandwidth: getIsLowBandwidth(), appConfig }) as BrightspotConfig

const brightspotConfig = getBrightspotWebConfig()

export default brightspotConfig
